import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import SportsMotorsportsIcon from "@material-ui/icons/SportsMotorsports";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import EventIcon from "@material-ui/icons/Event";

import Aux from "../../hoc/auxilliary";

import { withRouter } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    width: 380,
    marginTop: "2em",
    position: "fixed",
    right: "0",
    bottom: "0",
    marginBottom: "2em",
    "@media (max-height: 400px)": {
      display: "none",
    },
  },
});

//const styles = { //https://gist.github.com/nickpiesco/9bef21b4f9e236b4430e
//  smallerStyle: {
//      '@media (min-width: 800px)': {
//      width: '700px'
//    }
//  }
//};

const SimpleBottomNavigation = (props) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  //    const [currentState, setState]=useState(false);
  //
  //    useEffect(()=>{
  //
  //        console.log(currentState);
  //
  //        return ()=>{
  //
  //            console.log()
  //
  //            setState(true);
  //        }
  //    }, [])

  return (
    <Aux>
      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        showLabels
        className={classes.root}
      >
        <BottomNavigationAction
          label="VRC web"
          icon={<SportsMotorsportsIcon />}
          onTouchStart={() => {
            document.open(
              "https://virtualracingchampionship.com/",
              "_blank",
              "noopener=true"
            );
          }}
          onDoubleClick={() => {
            document.open(
              "https://virtualracingchampionship.com/",
              "_blank",
              "noopener=true"
            );
          }}
        />
        <BottomNavigationAction
          label="VRC forums"
          icon={<SportsMotorsportsIcon />}
          onTouchStart={() => {
            document.open(
              "http://vrc.createaforum.com/index.php",
              "_blank",
              "noopener=true"
            );
          }}
          onDoubleClick={() => {
            document.open(
              "http://vrc.createaforum.com/index.php",
              "_blank",
              "noopener=true"
            );
          }}
        />

        <BottomNavigationAction
          label="Events"
          icon={<EventIcon />}
          onTouchStart={() => {
            props.history.push("/events");
          }}
          onDoubleClick={() => {
            props.history.push("/events");
          }}
        />

        <BottomNavigationAction
          label="Contact"
          icon={<LocationOnIcon />}
          onTouchStart={() => {
            props.history.push("/contact");
          }}
          onDoubleClick={() => {
            props.history.push("/contact");
          }}
        />
      </BottomNavigation>
    </Aux>
  );
};

// style={styles.smallerStyle} //couldn't get this to work, but I found another solution, by just cutting the default width to 400, see the github link above for what I was trying to do
//<a href='http://vrc.createaforum.com/index.php' target='_blank' rel='noopener noreferrer'>
//</a>

export default withRouter(SimpleBottomNavigation);



// WEBPACK FOOTER //
// ./src/components/BottomNav/bottomnav.js